import axios from "axios";
import { useURL } from "../data/Config";
import { IApplication } from "../types";

export const getAllApplicationsByAdmin = async (
  searchQuery?: string
): Promise<IApplication[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(
    `${useURL}/applications/admin/get-all-applications`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );

  return response.data;
};

export const getApplicationCount = async (): Promise<number> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<number>(
    `${useURL}/applications/admin/count`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
